import cookies from 'js-cookie';
import { sanitizeId } from '../../../config/ab/util';

export const BSID_COOKIE_KEY = 'bsid';
export const SAW_CHECK_INSURANCE_MODAL_BSID_COOKIE_KEY = 'zd_saw_check_insurance_modal_bsid';

export const markCheckInsuranceModalShownInCurrentSession = () => {
    const currentBsid = sanitizeId(cookies.get(BSID_COOKIE_KEY));
    const storedBsid = cookies.get(SAW_CHECK_INSURANCE_MODAL_BSID_COOKIE_KEY);
    if (currentBsid === storedBsid) {
        return;
    }

    cookies.set(SAW_CHECK_INSURANCE_MODAL_BSID_COOKIE_KEY, currentBsid);
};

export const isCheckInsuranceModalAlreadyShownInCurrentSession = () => {
    const currentBsid = sanitizeId(cookies.get(BSID_COOKIE_KEY));
    const storedBsid = cookies.get(SAW_CHECK_INSURANCE_MODAL_BSID_COOKIE_KEY);
    return currentBsid === storedBsid;
};
